import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';
import ValidationUtils from '../../utils/validation';

const passwordValidationRules = (editPasswordForm) => ({
	fields: {
		currentPassword: {
			validators: {
				notEmpty: {
					message: 'Please enter your current password'
				}
			}
		},
		newPassword: {
			validators: {
				notEmpty: {
					message: 'Please enter a new password'
				},
				stringLength: {
					min: 8,
					max: 25,
					message: 'Please choose a password that is longer than 8 and fewer than 26 characters'
				},
				regexp: {
					regexp: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-.\\\/:;<=>?@[\]^_`{|}~])/g,
					message: 'Please enter at least one upper and lower case character, a number and a special character'
				},
			}
		},
		repeatPassword: {
			validators: {
				identical: {
					compare: () => editPasswordForm.querySelector('[name="newPassword"]').value,
					message: 'Please enter the same password twice'
				},
			}
		}
	},
	plugins: {
		trigger: new Trigger(),
		submitButton: new SubmitButton(),
		message: new Message({
			clazz: 'lta-text-input__label-instruction',
			container: function(field, element) {
				const fieldType = element.getAttribute('type');
				const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
				return inputWrapper.querySelector('.lta-text-input--error');
			}
		}),
	}
})

export default passwordValidationRules;
